/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Input } from "@chakra-ui/react";
import { LessIconInput, MoreIconInput } from "~misc/icons";
import { porcentagem } from "~services/GlobalServices";
import useParametros from "~/fetchs/useParametros";
import CurrencyInputAlternate from "./CurrencyInputAlternate";

const PercentageInput = ({
  value,
  type,
  setInput,
  input,
  inputName,
  invertButtons,
  max,
  min,
  inputEditable = false,
  diff,
  onBlur,
}) => {
  const initialPercentValue = parseFloat(value.replace("%", "")) || 0;
  const [percentValue, setPercentValue] = useState(initialPercentValue);
  const [percentIncrement, setPercentIncrement] = useState(1);

  const { getBySlug } = useParametros();

  useEffect(() => {
    getBySlug("simulator-increment-discount").then((parametro) => {
      if (parametro?.valor) setPercentIncrement(parseFloat(parametro?.valor));
    });
  }, []);

  useEffect(() => {
    // Update percentValue when the value prop changes
    const newPercentValue = parseFloat(value.replace("%", "")) || 0;
    setPercentValue(newPercentValue);
  }, [value]);

  const more = () => {
    let newValue = roundValue(percentValue + percentIncrement);

    if (invertButtons) newValue = roundValue(percentValue - percentIncrement);

    if (newValue > max && !invertButtons) return;

    if (newValue < min && invertButtons) return;

    setPercentValue(newValue);
  };

  const less = () => {
    let newValue = roundValue(percentValue - percentIncrement);

    if (invertButtons) newValue = roundValue(percentValue + percentIncrement);

    if (newValue < min && !invertButtons) return;

    if (newValue > max && invertButtons) return;

    setPercentValue(newValue);
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = parseFloat(inputValue.replace("%", ""));

    if (!isNaN(numericValue)) {
      setPercentValue(numericValue);
    } else {
      // Tratar caso em que a entrada não é um número válido
      setPercentValue(0);
    }
  };

  useEffect(() => {
    setInput(percentValue);
  }, [percentValue]);

  const roundValue = (value) => {
    let rounded = value;

    if (value > 0) rounded = Math.ceil(value / percentIncrement) * percentIncrement;
    else rounded = Math.floor(value / percentIncrement) * percentIncrement;

    return rounded;
  };

  const handleBlur = (e) => {
    if (onBlur && typeof onBlur == "function") onBlur(e);

    const rounded = roundValue(percentValue);

    setPercentValue(rounded);
  };

  return (
    <>
      {type === "default" ? (
        <div className="flex items-center justify-between text-white text-2xl font-bold relative color-black">
          <button type="button" onClick={less} className="p-2 absolute left-0 z-10 scale-75">
            <LessIconInput />
          </button>
          {inputEditable ? (
            <CurrencyInputAlternate
              diff={diff}
              type="text"
              inputName={inputName}
              input={percentValue}
              setInput={setPercentValue}
              center
              allowNegative
              suffix="%"
              prefix=""
              onBlur={handleBlur}
            />
          ) : (
            <Input
              value={porcentagem(percentValue)}
              onChange={handleChange}
              className="text-center text-black"
              name={inputName}
              readOnly={true}
            />
          )}
          <button type="button" onClick={more} className="p-2 absolute right-0 z-10 scale-75">
            <MoreIconInput />
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-center text-black text-md">
          <p className="">{porcentagem(percentValue)}</p>
        </div>
      )}
    </>
  );
};

export default PercentageInput;
